<template>
  <v-item >
   
    <v-col cols="12" md="4">
      <v-card :color="color" dark>
        <v-card-text>
          <v-row>
            <v-col>
              <div class="headline">{{ stat.nombre }}</div>
              <span class="caption">{{ subTitle }}</span>
            </v-col>
            <v-col>
              <v-btn icon :to="route">
                <v-icon size="76px" color="white" style="opacity: 0.6;">{{
                  icon
                }}</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        
      </v-card>
    </v-col> 
  </v-item>
</template>

<script>
export default {
  props: {
    supTitle: {
      type: String,
      required: false,
      default:""
    },
    subTitle: {
      type: String,
      required: false,
      default:""
    },
    stat: {
      type: Object,
      required: false,
     
    },
    icon: {
      type: String,
      required: false,
      default:"mdi-chevron-right"
    },
    color: {
      type: String,
      required: false,
      default:"primary"
    },
    route: {
      type: String,
      required: false,
      default:"/"
    },
  },

  data() {
    return {};
  },
};
</script>

<style scoped>
.v-application .headline {
  font-size: 3.7em !important;
}
</style>
